import React, { useState } from 'react';
import LeadInActivitiesExercise from './LeadInActivitiesExercise';
import './LeadInActivitiesExerciseBoard.css';

const LEAD_IN_ACTIVITIES_ICON = (
  <span style={{
    display: 'inline-flex', alignItems: 'center', justifyContent: 'center', width: 48, height: 48, borderRadius: 12, background: 'linear-gradient(135deg, #ee5a24 0%, #ff6b35 100%)', marginRight: 20
  }}>
    <svg width="28" height="28" viewBox="0 0 24 24" fill="white">
      <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-2 15l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z"/>
      <path d="M7 10l2 2 4-4"/>
      <path d="M12 6v2m0 8v2"/>
      <path d="M6 12h2m8 0h2"/>
      <path d="M9 9l6 6m0-6l-6 6"/>
      <path d="M8 8h8v8H8z"/>
      <path d="M4 4h4v4H4z"/>
      <path d="M16 16h4v4h-4z"/>
    </svg>
  </span>
);

const LeadInActivitiesExerciseBoard = ({
  exerciseData, exerciseType: _exerciseType, onUpdate, isSelected, onSelect, onExpand,
  isExpanded: isExpandedProp, onClose,
  isStudent = false, myState = {}, otherState = {}, updateState = () => {},
}) => {
  const [isExpandedLocal, setIsExpandedLocal] = useState(false);
  const isExpanded = isExpandedProp !== undefined ? isExpandedProp : isExpandedLocal;
  const { activities, title, level } = exerciseData;

  if (!activities || !Array.isArray(activities)) {
    return (
      <div className="lead-in-activities-board-error">
        <p>Error: Invalid Lead In Activities exercise data</p>
      </div>
    );
  }

  return (
    <div className="lead-in-activities-exercise-board">
      {!isExpanded ? (
        <div
          className="lead-in-activities-preview unified-exercise-preview"
          onClick={() => {
            if (isExpandedProp === undefined) setIsExpandedLocal(true);
            if (onSelect) onSelect();
            if (onExpand) onExpand();
          }}
          style={{
            border: isSelected ? '2px solid #3b82f6' : '1px solid #e5e7eb',
            borderRadius: '12px',
            padding: '20px',
            background: '#ffffff',
            cursor: 'pointer',
            transition: 'all 0.2s ease',
            boxShadow: isSelected ? '0 0 0 2px rgba(59, 130, 246, 0.2)' : '0 2px 8px rgba(0, 0, 0, 0.1)'
          }}
        >
          {LEAD_IN_ACTIVITIES_ICON}
          <div className="unified-preview-main">
            <div className="unified-preview-title">{title || 'Lead In Activities Exercise'}</div>
            <div className="unified-preview-meta">
              {activities.length} activities · Level: {level || 'B1'}
            </div>
          </div>
          <button className="unified-preview-btn">
            Start Exercise
          </button>
        </div>
      ) : (
        <div className="lead-in-activities-expanded">
          <LeadInActivitiesExercise
            activities={activities}
            title={title}
            level={level}
            onClose={() => { if (isExpandedProp === undefined) setIsExpandedLocal(false); if (onClose) onClose(); }}
            updateAttributes={onUpdate}
            isBoard={true}
            isStudent={isStudent}
            myState={myState}
            otherState={otherState}
            updateState={updateState}
          />
        </div>
      )}
    </div>
  );
};

export default LeadInActivitiesExerciseBoard; 